import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {NgxPermissionsService} from 'ngx-permissions';
import {combineLatest, map, of, tap} from 'rxjs';
import {ROUTER_PAGE_403} from "@shared/constants";

@Injectable({providedIn: 'root'})
export class CustomPermissionsGuard implements CanActivateChild {
  constructor(
    private router: Router,
    private permissionsService: NgxPermissionsService
  ) {
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const childRoute = route.firstChild;

    if (!childRoute) {
      return of(true);
    }

    // 2. Xem data.permissions của route con
    let permissionData = childRoute.data['permissions'];

    if (!permissionData) {
      permissionData = route.data['permissions'];
    }

    if (!permissionData) {
      return of(true);
    }

    const only = permissionData.only as (string | string[])[];
    const redirectTo = permissionData.redirectTo || ROUTER_PAGE_403;

    if (!only || only.length === 0) {
      return of(true);
    }


    const orGroups: string[][] = only.map(item =>
      Array.isArray(item) ? item : [item]
    );


    const groupChecks$ = orGroups.map(group => {
      if (group.length === 0) return of(true);
      const perms$ = group.map(perm => this.permissionsService.hasPermission(perm));
      return combineLatest(perms$).pipe(map(results => results.every(Boolean)));
    });


    return combineLatest(groupChecks$).pipe(
      map(results => results.some(val => val)),
      tap(can => {
        if (!can) {
          this.router.navigate([redirectTo]);
        }
      })
    );
  }
}
